<modal [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
    <p>Une erreur technique est survenue, cliquez pour réessayer</p>
    <ng-template #customModalFooter>
        <button class="button is-conversion mt-2" (click)="close()">Réessayez</button>
    </ng-template>
</modal>
